import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { ITeamMember } from '../../../types/teamMember';
import { RootState } from '../..';

interface IGetTeamMembersResponse {
  status?: boolean;
  message?: string;
  data?: ITeamMember[];
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetTeamMembersResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getTeamMembersAsync = createAsyncThunk(
  'teamMembers',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('/team-members?perPage=100', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const teamMembersGetSlice = createSlice({
  name: 'teamMembers/get',
  initialState,
  reducers: {
    resetGetTeamMembers: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeamMembersAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getTeamMembersAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetTeamMembersResponse;
      })
      .addCase(getTeamMembersAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetTeamMembersResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetTeamMembers } = teamMembersGetSlice.actions;

export default teamMembersGetSlice.reducer;
